
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
export default class Telefonos extends Vue {}
